export default __webpack_public_path__ + "static/media/new indexx.ai logo.680bb2bd.svg";